import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { pluginFactoryShape } from './helpers/propTypes';
import { ENTITY_TYPES } from './helpers/consts';
import useGetBulkLinkedEntities from './helpers/hooks/useGetBulkLinkedEntities';

const LinkedEntitiesContext = React.createContext();
const useLinkedEntitiesContext = () => {
  const context = useContext(LinkedEntitiesContext);
  return context;
};

const LinkedEntitiesProvider = ({
  children,
  ids,
  sourceEntityType,
  plugins = [],
  autoLoadMore = false
}) => {
  const contextValue = useGetBulkLinkedEntities({ ids, sourceEntityType, plugins, autoLoadMore });
  return (
    <LinkedEntitiesContext.Provider value={contextValue}>{children}</LinkedEntitiesContext.Provider>
  );
};

LinkedEntitiesProvider.propTypes = {
  /**
   * Elements to be provided with relationships data
   */
  children: PropTypes.node.isRequired,
  /**
   * List of entities to fetch their relationships
   */
  ids: PropTypes.arrayOf(PropTypes.string),
  /**
   *  The source entity type
   */
  sourceEntityType: PropTypes.oneOf(objectValues(ENTITY_TYPES)).isRequired,
  /**
   *  The target entity type plugins of relationship
   */
  plugins: PropTypes.arrayOf(pluginFactoryShape).isRequired,
  /**
   *  continue fetching when reaching server's limit
   */
  autoLoadMore: PropTypes.bool
};

export { useLinkedEntitiesContext };
export default LinkedEntitiesProvider;
